import { useEffect, useRef, useState } from "react";
import api from "../lib/api";

export default function AuthImage({
  path,
  src,
  alt = "",
  className,
  placeholderClassName = "auth-image-ph",
  loadingLabel = "Loading render…",
  errorLabel = "Preview could not be loaded.",
  onError,
}) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  useEffect(() => {
    let revoke;
    let cancelled = false;
    async function load() {
      setError(null);
      setUrl(null);
      if (src && !path) {
        if (!cancelled) setUrl(src);
        return;
      }
      if (!path) return;
      try {
        const { data } = await api.get(path, { responseType: "blob" });
        const next = URL.createObjectURL(data);
        revoke = next;
        if (!cancelled) setUrl(next);
      } catch {
        if (!cancelled) {
          setError(errorLabel);
          onErrorRef.current?.();
        }
      }
    }
    load();
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path, src, errorLabel]);

  if (error) return <div className={placeholderClassName}>{error}</div>;
  if (!path && !src) return null;
  if (!url) return <div className={placeholderClassName}>{loadingLabel}</div>;
  return <img className={className} src={url} alt={alt} />;
}
